import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BreadcrumbLink, BreadcrumbsTextLi, BreadcrumbsWrapper } from './styles';
export const Breadcrumbs = ({ children, ...rest }) => {
    return (_jsx("nav", { ...rest, children: _jsx(BreadcrumbsWrapper, { children: children }) }));
};
export const Breadcrumb = ({ as, children, currentPage = false, ...props }) => {
    return (_jsxs(BreadcrumbsTextLi, { children: [_jsx(BreadcrumbLink, { forwardedAs: as, ...props, "aria-current": currentPage ? 'page' : undefined, "$currentPage": currentPage, tabIndex: 0, children: children }), `\u00A0${!currentPage ? '/\u00A0' : ''}`] }));
};
//# sourceMappingURL=index.js.map